module.exports = __webpack_public_path__ + "static/img/introduce-m@2x.7eff61b6.png";